import { WizardStep } from '@apply/components';
import { useWizardDemoStore } from '../../state/wizardDemoStore';
import { SetupAndBorrower } from './components/SetupAndBorrower';
import { Property } from './components/Property/Property';
import { getPropertyProgress } from './components/Property/constants/propertyForm';
import { ApplicationAndKeyItems } from './components/ApplicationAndKeyItems/ApplicationAndKeyItems';
import { getApplicationKeyItemsProgress } from './components/ApplicationAndKeyItems/constants/applicationKeyItemsForm';
import { Underwriting } from './components/Underwriting';
import { LoanAtApplication } from './components/LoanAtApplication';

/** The wizard's sections, in order. The value is the step number shown in the sidebar bubble. */
export enum WizardDemoSection {
    SetupAndBorrower = 1,
    Property = 2,
    ApplicationAndKeyItems = 3,
    Underwriting = 4,
    LoanAtApplication = 5,
}

/** The wizard's steps. Each step's progress comes from the form data in the wizard store. */
export const useSteps = (): WizardStep[] => {
    const property = useWizardDemoStore((state) => state.property);
    const applicationKeyItems = useWizardDemoStore((state) => state.applicationKeyItems);

    return [
        {
            number: WizardDemoSection.SetupAndBorrower,
            label: 'Setup & Borrower',
            header: 'Setup & Borrower',
            content: <SetupAndBorrower />,
        },
        {
            number: WizardDemoSection.Property,
            label: 'Property',
            header: 'Property',
            content: <Property />,
            progressBarInfo: getPropertyProgress(property),
        },
        {
            number: WizardDemoSection.ApplicationAndKeyItems,
            label: 'Application & Key Items',
            header: 'Application & Key Items',
            content: <ApplicationAndKeyItems />,
            progressBarInfo: getApplicationKeyItemsProgress(applicationKeyItems),
        },
        {
            number: WizardDemoSection.Underwriting,
            label: 'Underwriting',
            header: 'Underwriting',
            content: <Underwriting />,
        },
        {
            number: WizardDemoSection.LoanAtApplication,
            label: 'Loan at Application',
            header: 'Loan at Application',
            content: <LoanAtApplication />,
        },
    ];
};
